import { Component, EventEmitter, Input, Output, ViewChild } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ForumModalComponent } from 'src/app/pages/forum-modal/forum-modal.component';
import { getDMYFromTimestamp, getIntFormatFromTimestamp } from 'src/app/shared/utils/date.util';
import { CoursesService } from 'src/app/services/courses.service';
import { UserProfileService } from 'src/app/services/user-profile.service';
import { CommentsTribeService } from 'src/app/services/comments-tribe.service';
import {
  AttributesItribes,
  ITribesResponse,
} from 'src/app/shared/interfaces/tribe.interface';
import {
  ICommentTribeNested,
  ICommentTribeNestedWithUser,
  ICommentTribeWithUser,
} from 'src/app/shared/interfaces/comment-tribe.interface';
import { IUserProfileComplete } from 'src/app/shared/interfaces/profile.interface';
import { getNestTribeComments } from 'src/app/shared/utils/commentsTribes.util';
import { CardCommentTribeComponent } from '../../cards/card-comment-tribe/card-comment-tribe.component';
import { InputCommentTribeComponent } from '../../input-comment-tribe/input-comment-tribe.component';
import { ModalSideComponent } from '../../modal-side/modal-side.component';
import { ModalTribeServiceService } from 'src/app/services/modal-tribe-service.service';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-row-tribe,[app-row-tribe]',
  standalone: true,
  imports: [
    CommonModule,
    ForumModalComponent,
    CardCommentTribeComponent,
    InputCommentTribeComponent,
    ModalSideComponent,
  ],
  templateUrl: './row.component.html',
  styleUrls: ['./row.component.scss'],
})
export class RowComponent {
  @Input() tribe: ITribesResponse = null as any;
  @Output() commentCreatedEvent = new EventEmitter<ITribesResponse>();
  //param idProfile: string, tribeId: number
  @Output() onClickRow = new EventEmitter<{tribeSelected: ITribesResponse}>();
  // @Output() onClickOpenModal = new EventEmitter<ITribes>();

  lastInteraction: Date | string = '- /- / -';
  courseTitle: string = '---';
  getResultCommentCreated = Subscription.EMPTY;
  OriginalComments:any[]=[]
  loadingCourse: boolean = true;
  dataModal: {
    ownerProfile: IUserProfileComplete;
    comments: ICommentTribeNested[];
    attributes: AttributesItribes;
  } = {} as {
    ownerProfile: IUserProfileComplete;
    comments: ICommentTribeNested[];
    attributes: AttributesItribes;
  };

  @ViewChild('modalSide', { static: true }) modalSlide:
    | ModalSideComponent
    | undefined;

  constructor(
    private courseService: CoursesService,
    private userProfileService: UserProfileService,
    private commetTribeService: CommentsTribeService,
    protected modalTribeService: ModalTribeServiceService
  ) {

  }






  ngOnInit(): void {
    // console.log('NG INIT  in rowww QUE EVNIA AL OBERSER:', this.tribe);
    this.loadingCourse = true
    this.courseService
      .getCourseById(this.tribe.relationships.field_course.data.id)
      .subscribe((c: any) => {

        this.courseTitle = c.attributes.title;
      });

    this.lastInteraction = getIntFormatFromTimestamp(
      this.tribe.attributes.comment_forum.last_comment_timestamp
    );
    this.loadingCourse = false;
  }


  async getComment(subject:string){
    /// this function is for commenting in root of the forum tribe
    const commentInRootTribe = null;
    this.commetTribeService.createCommentTribe(this.tribe.id,subject,commentInRootTribe).subscribe(({data}:any) => {
      const element = data;
      const dataForNested = {
        id_tribe: element.relationships.entity_id.data.id,
        uuid_tribe: element.relationships.entity_id.data.id,
        target_uuid: element.relationships.entity_id.data.id,
        id_comment: element.id,
        // field_name:element.attributes.field_name,
        status: element.attributes.status,
        subject: element.attributes.subject,
        user_uid: element.relationships.uid.data.id,
        // entity_id:element.attributes.entity_id[0].target_id,
        created: element.attributes.created,
        changed: element.attributes.changed,
        thread: element.attributes.thread,
        thread_array: element.attributes.thread
          .replaceAll('/', '')
          .split('.'),
        comment_body: element.attributes.comment_body.value,
      };
      this.OriginalComments.push(dataForNested);
      this.dataModal.comments = getNestTribeComments([...this.OriginalComments]).reverse();
      // console.log("llego a row el comment y se envio al observer",subject);
      this.commentCreatedEvent.emit(this.tribe); //doesnt do anything
    });

  }


onClickLocalRow(tribeSelected: ITribesResponse){
  this.onClickRow.emit({tribeSelected});
}


}
